import { forwardRef, ReactNode } from "react";
import styled from "./styled.module.scss";

interface IComponentProps {
  children: ReactNode;
}

const CustomPopup = forwardRef<HTMLDivElement, IComponentProps>(
  (props, ref) => (
    <div ref={ref} className={styled.popup}>
      {props.children}
    </div>
  ),
);

export default CustomPopup;
